// extracted by mini-css-extract-plugin
module.exports = {"outer":"styles_outer__oAVW3","wrapper":"styles_wrapper__AXp9f","word":"styles_word__iMjhs","active":"styles_active__2ak69"};